import apiClient from '../axios.js'

/**
 * 選單服務
 */
export const menuService = {
    /**
     * 獲取當前用戶可用的程式選單
     * @returns {Promise<Object>} 選單資料
     */
    getMenu: async () => {
        try {
            const response = await apiClient.get('/programs/menu')
            return response
        } catch (error) {
            throw error
        }
    },
}
